import React, { Suspense } from 'react';

// eslint-disable-next-line no-restricted-imports
import { overlayState } from 'app/gamma/src/modules/state/ui/overlay';
import { useLazyComponent } from '@trello/use-lazy-component';
import { useSharedState } from '@trello/shared-state';
import { ReduxProvider } from 'app/src/components/ReduxProvider';

export const Overlays = () => {
  let component = null;

  const PlanSelectionOverlay = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "plan-selection-overlay" */ 'app/src/components/FreeTrial'
      ),
    {
      preload: false,
      namedImport: 'PlanSelectionOverlayConnected',
    },
  );
  const AtlassianAccountMigrationStageOverlays = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "atlassian-account-migration" */ 'app/src/components/AtlassianAccountMigrationStage'
      ),
    { namedImport: 'AtlassianAccountMigrationStageOverlays', preload: false },
  );

  const [overlay, setOverlayState] = useSharedState(overlayState);

  if (overlay.overlayType === 'plan-selection') {
    component = overlay.context?.orgId && (
      <PlanSelectionOverlay
        orgId={overlay.context?.orgId}
        startFreeTrialOptions={{ redirect: overlay.context?.redirect }}
        // eslint-disable-next-line react/jsx-no-bind
        onClose={() => {
          setOverlayState({
            overlayType: null,
            context: {},
          });
        }}
      />
    );
  }

  return (
    <Suspense fallback={null}>
      {component}
      <AtlassianAccountMigrationStageOverlays />
    </Suspense>
  );
};

export const WithReduxProvider = () => {
  return (
    <ReduxProvider>
      <Overlays />
    </ReduxProvider>
  );
};
